module.exports = __webpack_public_path__ + "img/28.e5579429.jpg";